import { useNavigate } from "react-router-dom";
import { extractContactMenuAccess } from "../../../shared/utils/extractContactMenuAccess";

const ContactHeader = ({selectedContact}) => {
  const navigate = useNavigate();
  const handleContactDashboardNavigation = () => {
    const {flags, defaultAssetSubMenu} = extractContactMenuAccess();
    if(flags){
      if(defaultAssetSubMenu?.webMenuName){
        if(defaultAssetSubMenu?.webMenuName === 'Overview'){
          navigate(`/Asset/Overview/${btoa(selectedContact.webUserId)}`)
        }
        if(defaultAssetSubMenu?.webMenuName === 'Details'){
          navigate(`/Asset/Details/${btoa(selectedContact.webUserId)}`)
        }
        if(defaultAssetSubMenu?.webMenuName === 'Holdings'){
          navigate(`/Asset/Holdings/${btoa(selectedContact.webUserId)}`)
        }
      }
      else{
        navigate(`/Asset/Overview/${btoa(selectedContact.webUserId)}`)
      }
    }
  }
  return (
    <section className="section-header">
      <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
        <div className="col-4">
          <label className="control-label">Contact: </label>
          <span style={{ fontWeight: "normal" }}>
            {selectedContact.webUserName}
          </span>
        </div>

        <div style={{display:'flex', flexDirection:'row', justifyContent:'end', gap:"10px"}}>
          <button className="btn btn-primary btnPrimary me-2" onClick={handleContactDashboardNavigation}>
            Contact View
          </button>
          <button 
          className="btn btn-secondary btnSecondary"
          onClick={()=>{
            navigate('.',{state:{showEmailDialouge:true}})
          }}
          >
            Email to Contact
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactHeader;